import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import img from "../IMAGEN/spinner.gif";

function CrearSolicitudEspecial() {
  const [isLoading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);

  const [archivos, setArchivos] = useState(null);
  const [postNombreCliente, setPostNombreCliente] = useState("");
  const [postDescripcion, setPostDescripcion] = useState("");
  const [postClasificacionComercial, setPostClasificacionComercial] =
    useState("");
  const [postCampoObservacion, setPostCampoObservacion] = useState("");
  const [postTitulo, setPostTitulo] = useState("");

  const cookie = new Cookies();
  const userId = cookie.get("id");
  const userCorreo = cookie.get("correo");

  const abrirModal = () => setIsOpen(true);
  const cerrarModal = () => setIsOpen(false);

  const subirArchivos = (e) => {
    setArchivos(e.target.files);
  };

  const mostrarMensaje = (title, text, icon) =>
    Swal.fire({ title, text, icon });

  const insertarSolicitud = async (e) => {
    e.preventDefault();
    setLoading(true);

    const urlBase = "https://educacionapi.azurewebsites.net/api";
    let urlAdjunto = "";

    try {
      // Si hay archivos, subirlos primero
      if (archivos?.length) {
        const formData = new FormData();
        Array.from(archivos).forEach((file) => {
          const random = Math.floor(100000 + Math.random() * 900000); // Genera número de 6 dígitos
          const newFileName = `${random}_${file.name}`;

          // Crear nuevo archivo con el nuevo nombre
          const renamedFile = new File([file], newFileName, {
            type: file.type,
          });
          formData.append("files", renamedFile);
        });

        const resAdjunto = await axios.post(
          `${urlBase}/AdjuntaArchivos`,
          formData
        );
        urlAdjunto = resAdjunto?.data?.fileURL || "";
      }

      // Crear cuerpo del JSON para CreaEspecial
      const body = {
        NombreCliente: postNombreCliente,
        Descripcion: postDescripcion,
        LineaServicio: postClasificacionComercial,
        Titulo: postTitulo,
        Observaciones: postCampoObservacion,
        Adjunto: urlAdjunto,
        Estado: 18,
        FechaCreacion: new Date(),
        UsuarioId: parseInt(userId),
        Vencido: 0,
        Correo: userCorreo,
      };

      // Enviar solicitud
      await axios.post(`${urlBase}/CreaEspecial`, body);

      mostrarMensaje(
        "Añadido con éxito",
        "Haga clic para continuar",
        "success"
      ).then(() => {
        window.location.reload();
      });
    } catch (error) {
      console.error(error);
      mostrarMensaje(
        "Error",
        "Hubo un problema al guardar la solicitud.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };
  const closeModal = () => setIsOpen(false);
  return (
    <div>
      <button className="btn btn-primary" onClick={abrirModal}>
        Nueva Solicitud Especial
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={cerrarModal}
        contentLabel="Crear"
      >
        <br></br> <br></br>
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Crear Solicitud
              </h6>
            </div>
            <div className="card-body">
              <form className="user" onSubmit={insertarSolicitud}>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nombre Cliente"
                    onChange={(e) => setPostNombreCliente(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Descripción</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    maxLength={600}
                    onChange={(e) => setPostDescripcion(e.target.value)}
                    required
                  ></textarea>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6">
                    <select
                      className="form-control"
                      onChange={(e) =>
                        setPostClasificacionComercial(e.target.value)
                      }
                      required
                    >
                      <option value="">Línea de servicio</option>
                      <option value="Proyecto Especial">
                        Proyecto Especial
                      </option>
                      <option value="Asistencia técnica desarrollo sostenible">
                        Asistencia técnica desarrollo sostenible
                      </option>
                      <option value="Optimizacion Proceso">
                        Optimización de procesos
                      </option>
                    </select>
                  </div>

                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Título / nombre servicio requerido"
                      onChange={(e) => setPostTitulo(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    className="form-control"
                    placeholder="Campo de observación (Requerimientos opcionales)"
                    maxLength={600}
                    onChange={(e) => setPostCampoObservacion(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Adjuntar archivo (opcional)</label>
                  <input
                    type="file"
                    className="form-control"
                    multiple
                    onChange={subirArchivos}
                  />
                </div>

                <div className="text-center">
                  {!isLoading ? (
                    <button className="btn btn-primary" type="submit">
                      Guardar
                    </button>
                  ) : (
                    <button className="btn btn-secondary" disabled>
                      <i className="fas fa-spinner fa-spin"></i> Cargando...
                      <img
                        src={img}
                        alt="loading"
                        style={{ width: 70, height: 70 }}
                      />
                    </button>
                  )}
                  <hr />
                  <button className="btn btn-secondary" onClick={closeModal}>
                    Volver
                  </button>
                </div>
              </form>
              <hr />
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CrearSolicitudEspecial;
